import React from 'react';
import * as ReactDOMClient from 'react-dom/client';

declare global {
  interface Window {
    React?: typeof React;
    ReactDOM?: typeof ReactDOMClient;
  }
}

function registerGlobals() {
  if (typeof window === 'undefined') {
    return;
  }

  window.React = React;
  window.ReactDOM = ReactDOMClient;
}

registerGlobals();

export { React, ReactDOMClient };
